import React from 'react';
import { rhythm } from '../utils/typography';

export default (props) => (
  <h1
    {...props}
    style={{
      marginBottom: rhythm(0.25),
    }}
  />
);



// WEBPACK FOOTER //
// ./src/components/Title.js